import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Grid/Grid.Item.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var DEFAULT_COMPONENT = "div";
var GridItem = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children
    } = _b,
    rest = __objRest(_b, ["as", "children"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */jsx(Component, __spreadProps(__spreadValues({
    ref
  }, rest), {
    children
  }));
});
var StoryGridItem = args => /* @__PURE__ */jsx(GridItem, __spreadValues({}, args));
var Grid_Item_default = GridItem;
export { StoryGridItem, Grid_Item_default };